import { FavouriteConditionValue } from 'app/types-shared';
import { ConditionValuesOperator, OptionTypes } from 'app/components/filters/types';

export const createFieldOptionType = (values: FavouriteConditionValue[]) => {
  return values
    .map(item => {
      const newItem = {
        [ConditionValuesOperator.empty]: OptionTypes.NotSpecified
      };
      return (item.operator && newItem[item.operator.v]);
    });
};
